import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";

const BackButton = ({ ...defaultProps }: React.ButtonHTMLAttributes<HTMLButtonElement>) => {
  const { t } = useTranslation();

  return (
    <button {...defaultProps} className={styles.backButton}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="8"
        height="15"
        viewBox="0 0 8 15"
        fill="none"
        aria-hidden="true"
        focusable="false"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.215066 13.1107C-0.0716888 13.4052 -0.0716887 13.8666 0.215066 14.1611C0.358596 14.3013 0.553564 14.3801 0.756898 14.3801C0.960233 14.3801 1.1552 14.3013 1.29873 14.1611L7.5021 8.12912C7.60522 8.09322 7.70204 8.03519 7.78478 7.95502C7.9412 7.79422 8.01236 7.58382 7.99825 7.37789C8.01167 7.17297 7.94051 6.9638 7.78478 6.80388C7.70268 6.72433 7.60671 6.66658 7.50448 6.63062L1.29873 0.597815C0.999062 0.307475 0.514735 0.307475 0.215066 0.597815C-0.071689 0.892285 -0.071689 1.35371 0.215066 1.64818L6.10919 7.37945L0.215066 13.1107Z"
          fill="currentColor"
        ></path>
      </svg>
      <span>{t("back")}</span>
    </button>
  );
};

export default BackButton;
